const columnsList = [
  {
    title: "Index",
    key: "stt",
    slots: { title: "stt" },
    scopedSlots: { customRender: "stt" },
    align: "center",
    width: 80,
  },
  //   {
  //     title: "Mã Năm",
  //     dataIndex: "MaNam",
  //     align: "center",
  //     key: "MaNam",
  //   },
  // {
  //   title: "Nhân Viên",
  //   dataIndex: "employee",
  //   align: "center",
  //   key: "NhanVien",
  //   scopedSlots: { customRender: "employee" },
  // },
  {
    title: "Type Leave",
    dataIndex: "typeWorkLeave",
    key: "typeWorkLeave",
    scopedSlots: { customRender: "typeWorkLeave" },
  },
  {
    title: "Benefit",
    dataIndex: "typeWorkLeave",
    key: "CheDo",
    scopedSlots: { customRender: "benefit" },
  },
  // {
  //   title: "Trạng thái",
  //   dataIndex: "status",
  //   key: "status",
  //   scopedSlots: { customRender: "TrangThai" },
  // },
  {
    title: "Total Leave Day",
    dataIndex: "totalLeaveDays",
    key: "totalLeaveDays",
    align: "center",
    scopedSlots: { customRender: "totalLeaveDays" },
  },
  {
    title: "Total Leave Hour",
    dataIndex: "totalLeaveHours",
    key: "totalLeaveHours",
    align: "center",
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    key: "createdAt",
    scopedSlots: { customRender: "createdAt" },
  },

  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    width: 100,
  },
];

export { columnsList };
